import { apiSlice } from "./apiSlice";

export const UserAssetSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getUserProjectAssets: builder.query({
            query: ({ projectId, userId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId);
                params.set("userId", userId);
                return {
                    url: `/Account/user/assets?${params.toString()}`,
                    method: "GET",
                };
            },
        }),


        createBulkUserAssets: builder.mutation({
            query: (payload) => {
                return {
                    url: "UserAsset/bulk-create",
                    method: "POST",
                    body: payload
                }
            }
        }),

        updateBulkUserAssets: builder.mutation({
            query: (payload) => {
                return {
                    url: "UserAsset/bulk-update",
                    method: "PUT",
                    body: payload
                }
            }
        })


    }),

});

export const {
    useGetUserProjectAssetsQuery,
    useLazyGetUserProjectAssetsQuery,
    useCreateBulkUserAssetsMutation,
    useUpdateBulkUserAssetsMutation
} = UserAssetSlice;